import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

// components
import Input from "./Input/Input";
import Button from "./Button/Button";
import Header from "./Header/Header";

// utils
import { resetPassword } from "src/utils/requests/register_screen/reset";

const PasswordForm = ({ changeForm }) => {
  let { code } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password === "" || repassword === "") {
      toast.info("Please filled out the required fields");
      return;
    }

    if (password !== repassword) {
      toast.info("password not matched");
    } else {
      resetPassword(password, code)
        .then((res) => {
          if (res.data.Status) {
            toast.success("password reset");
            setLoading(false);
            history.push("/login");
            window.location.reload();
          } else {
            toast.error(res.data.ErrorMessage);
            setLoading(false);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  return (
    <form>
      <Header
        title="Create Password"
        subTitle="Create your new password to login"
        icon
        handleChange={() => changeForm(1)}
      />
      <div className="sm-space-20"></div>
      <Input
        label="Password"
        placeholder="Password"
        type="password"
        icon="true"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Input
        label="Confirm Password"
        placeholder="Confirm Password"
        type="password"
        icon="true"
        value={repassword}
        onChange={(e) => setRepassword(e.target.value)}
      />
      <div className="sm-space-140"></div>
      <Button
        label={!loading ? "SET PASSWORD" : "loading..."}
        fill
        handleClick={handleSubmit}
      />
    </form>
  );
};

export default PasswordForm;
